export default class Detector {
  static platform() {
    const maxTouchPoints = window.navigator.maxTouchPoints
    const userAgent = window.navigator.userAgent

    if (/Android/i.test(userAgent)) {
      return "android"
      // maxTouchPoints is the only effective method to detect iPad iOS 13+
      // FMI https://developer.apple.com/forums/thread/119186
    } else if (
      (!(window as any).MSStream && !/X11|Linux|Windows/i.test(userAgent) && maxTouchPoints && maxTouchPoints > 0) ||
      /iPhone|iPad|iPod/i.test(userAgent)
    ) {
      return "ios"
    }
  }

  /**
   * Detects if the current browser is mobile Safari on iOS
   * This specifically detects Safari on iPhone/iPad, not other browsers on iOS
   */
  static isMobileSafari() {
    if (typeof window === "undefined") return false

    const userAgent = window.navigator.userAgent
    const isSafari = /Safari/.test(userAgent) && !/Chrome/.test(userAgent) && !/CriOS/.test(userAgent)
    const isIOS = /iPad|iPhone|iPod/.test(userAgent)

    return isSafari && isIOS
  }

  /**
   * Detects if the current browser is on a mobile device (iOS or Android)
   */
  static isMobile() {
    if (typeof window === "undefined") return false

    const userAgent = window.navigator.userAgent
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)
  }

  /**
   * Detects if the current browser is on iOS (any browser)
   */
  static isIOS() {
    if (typeof window === "undefined") return false

    const userAgent = window.navigator.userAgent
    return /iPad|iPhone|iPod/.test(userAgent)
  }
}
